import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/components/AppShell";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AdminUsers from "@/pages/AdminUsers";
import AdminAvisos from "@/pages/AdminAvisos";
import StudentArea from "@/pages/StudentArea";
import Eventos from "@/pages/Eventos";
import Unidades from "@/pages/Unidades";
import MeusDados from "@/pages/MeusDados";
import Pendencias from "@/pages/Pendencias";
import Validacoes from "@/pages/Validacoes";
import Presenca from "@/pages/Presenca";
import Galeria from "@/pages/Galeria";
import Certificados from "@/pages/Certificados";
import Placar from "@/pages/Placar";
import Cronometro from "@/pages/Cronometro";
import PlanoAula from "@/pages/PlanoAula";
import Frequencia from "@/pages/Frequencia";
import CargaMassiva from "@/pages/CargaMassiva";
import Recuperar from "@/pages/Recuperar";
import ResetarSenha from "@/pages/ResetarSenha";
import AutorizarTermo from "@/pages/AutorizarTermo";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-obsidian min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/usuarios" element={<AdminUsers />} />
            <Route path="/admin/avisos" element={<AdminAvisos />} />
            <Route path="/painel" element={<StudentArea />} />
            <Route path="/eventos" element={<Eventos />} />
            <Route path="/unidades" element={<Unidades />} />
            <Route path="/aluno/dados" element={<MeusDados />} />
            <Route path="/aluno/pendencias" element={<Pendencias />} />
            <Route path="/validacoes" element={<Validacoes />} />
            <Route path="/presenca" element={<Presenca />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/placar" element={<Placar />} />
            <Route path="/cronometro" element={<Cronometro />} />
            <Route path="/plano-aula" element={<PlanoAula />} />
            <Route path="/frequencia" element={<Frequencia />} />
            <Route path="/carga-massiva" element={<CargaMassiva />} />
            <Route path="/certificados" element={<Certificados />} />
            <Route path="/recuperar" element={<Recuperar />} />
            <Route path="/resetar-senha" element={<ResetarSenha />} />
            <Route path="/autorizar-termo" element={<AutorizarTermo />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121215", border: "1px solid rgba(212,175,55,0.3)", color: "#F5F5F0" } }} />
    </div>
  );
}

export default App;
